import * as types from '../mutation-types'
import axios from 'axios'
import router from '../../router'
import Vue from 'vue'

// initial state
const state = {
  user: {
    name: 'No :User Connected',
    loginId: '',
    userId: '',
    authorization: 'token',
    langPref: 'en',
    group: [],
    permission: 0
  }
}

// getters
const getters = {
  // getters
  getRolePerm: function (state) {
    return state.permission
  },
  getRole: function (state) {
    return state.group
  },
  isUserValid: function (state) {
    if (state.user.id === 0) {
      return false
    }
    return true
  },
  getLoginId: function (state) {
    return state.user.loginId
  },
  getuserId: function (state) {
    return state.user.userId
  }
}

const mutations = {
  [types.STORE_LOGIN] (state, data) {
    state.user.authorization = data.headers.authorization
    state.user.loginId = data.currentLoginId
    // state.user.permission = data.permission
    state.user.group = data.group
    router.push({ name: 'pathselector' })
  },
  [types.STORE_SET_LANG_PREF] (state, opt) {
    state.user.langPref = opt
  },
  [types.STORE_CLEAR_ALL] (state) {
    let keys = Object.keys(state)
    for (let i = 0; i < keys.length; i++) {
      state[keys[i]] = {}
    }
  }
}

const actions = {
  validateUser (context, userObject) {
    userObject.appVersion = '1.0'
    axios
      .post(window.lcmsserver + '/o/lcmslogin/validateuser', userObject)
      .then(response => {
        if (response != null && response.data === 'User_Not_Found') {
          Vue.toasted.error('Hi, User not Found', {
            theme: 'bubble',
            duration: 6000
          })
          router.push({ name: 'login' })
        } else {
          response.currentLoginId = userObject.loginId
          Vue.toasted.success('Hi, Welcome to Lcms !', {
            theme: 'bubble',
            duration: 6000
          })
          context.commit(types.STORE_LOGIN, response)
        }
      })
      .catch(e => {
        console.log(e)
        if (e.response.status === 417) {
          Vue.toasted.error('Invalid UserName & Password..', {
            theme: 'bubble',
            duration: 6000
          })
        } else {
          Vue.toasted.error(e, {
            theme: 'bubble',
            duration: 6000
          })
        }
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js